import { ITestimonial, ITestimonialAudio, ITestimonialText, ITestimonialVideo } from "@/models/vimy.models";
import { VuexModule, Module, RegisterOptions, Mutation, Action } from "vuex-class-modules";

export type TestimonialTypes = ITestimonial | ITestimonialAudio | ITestimonialText | ITestimonialVideo;

export interface IOpenTestimonialEvent extends Event {
    detail: TestimonialTypes;
}

/* DOC: HOW TO CALL THE CUSTOM EVENT
            // JS
            const event = new CustomEvent('set-testimonial', { detail: {
                type: 'text',
                content: '<p>TEST</p>',
                image: '',
                language: 'fr',
                title: 'test',
                subheading: 'test',
            }});

            document.dispatchEvent(event);

            // TS
            const event = new CustomEvent<ITestimonialText>('set-testimonial', { detail: {
                type: 'text',
                content: '<p>TEST</p>',
                image: '',
                language: 'fr',
                title: 'test',
                subheading: 'test',
            }});

            document.dispatchEvent(event);
        */

@Module
export class TestimonialModule extends VuexModule {
    private _testimonial!: ITestimonial;
    private _open: number = 0;

    constructor(options: RegisterOptions) {
        super(options);

        setTimeout(() => {
            document.addEventListener('set-testimonial', (ev) => {
                this.setTestimonial((ev as CustomEvent<TestimonialTypes>).detail);
            });
    
            document.addEventListener('open-testimonial', () => {
                this.openTestimonial();
            });
        }, 500);
    }

    get testimonial(): ITestimonial {
        return this._testimonial;
    }

    get open(): number {
        return this._open;
    }

    @Mutation
    private _setTestimonial(testimonial: ITestimonial) {
        this._testimonial = testimonial;
    }

    @Mutation
    private triggerOpen() {
        this._open++;
    }

    @Action
    openTestimonial(): void {
        this.triggerOpen();
    }

    @Action
    setTestimonial(testimonial: ITestimonial): void {
        this._setTestimonial(testimonial);
        this.openTestimonial();
    }
}